type SearchData = {
  id: string;
  name: string;
  url: string;
  excludeLang?: boolean;
  icon: string;
  section: string;
  shortcut?: string;
};

const data: SearchData[] = [
  {
    id: "2",
    name: "Analytics Dashboard",
    url: "/dashboards/analytics",
    icon: "tabler-trending-up",
    section: "Dashboards",
  },

  {
    id: "35",
    name: "Admin Users",
    url: "/apps/user/admin-users",
    icon: "tabler-user",
    section: "Apps",
  },
  {
    id: "35b",
    name: "Client Users",
    url: "/apps/user/client-users",
    icon: "tabler-user",
    section: "Apps",
  },
  {
    id: "35c",
    name: "Business Users",
    url: "/apps/user/business-users",
    icon: "tabler-user",
    section: "Apps",
  },

  {
    id: "37",
    name: "Roles",
    url: "/apps/roles",
    icon: "tabler-user-shield",
    section: "Apps",
  },
  {
    id: "38",
    name: "Permissions",
    url: "/apps/permissions",
    icon: "tabler-lock",
    section: "Apps",
  },
  {
    id: "43",
    name: "Content Moderation",
    url: "/apps/content-moderation/review-queue",
    icon: "tabler-flag",
    section: "Apps",
  },
  {
    id: "44",
    name: "Review Queue",
    url: "/apps/content-moderation/review-queue",
    icon: "tabler-list-check",
    section: "Apps",
  },
  {
    id: "45",
    name: "Reported Content",
    url: "/apps/content-moderation/reported",
    icon: "tabler-alert-triangle",
    section: "Apps",
  },

  {
    id: "40",
    name: "Account Settings",
    url: "/pages/account-settings",
    icon: "tabler-settings",
    section: "Pages",
  },
  {
    id: "41",
    name: "FAQ",
    url: "/pages/faq",
    icon: "tabler-help-circle",
    section: "Pages",
  },
  {
    id: "42",
    name: "Security",
    url: "/pages/account-settings-security",
    icon: "tabler-settings",
    section: "Pages",
  },
];

export default data;
